export default "__VITE_ASSET__YxhVWYrs__"